import { useQuery } from "@tanstack/react-query";
import { rolesAdminQueryOptions } from "@/features/admin-roles/hooks/use-roles-admin";

/**
 * Nombres de TODOS los roles asignables a un usuario (sistema + personalizados),
 * traídos del backend (`/admin/roles`). Reemplaza la lista HARDCODED
 * `ROLES_DISPONIBLES` · así los roles personalizados creados por el admin (RBAC ·
 * Ruta B) también se pueden asignar desde el gestor de usuarios.
 */
export function useRolesDisponibles(): string[] {
  const { data } = useQuery(rolesAdminQueryOptions);
  return (data ?? []).map((r) => r.nombre);
}
